import { Dispatch, SetStateAction, useEffect, useState } from 'react';

/**
 * NOTE: Pass `undefined` to remove the item from sessionStorage.
 */
export default function useSessionStorage<T>(
  key: string,
  initialValue?: T
): [value: T, setValue: Dispatch<SetStateAction<T>>] {
  const [value, setValue] = useState<T>(() => {
    if (typeof window === 'undefined') return;
    try {
      // Get initial value from existing one in sessionStorage, or from initialValue
      const item = sessionStorage.getItem(key);
      return item ? JSON.parse(item) : initialValue;
    } catch (err) {
      console.log(err);
      return initialValue;
    }
  });

  // Always update sessionStorage whenever the value changes
  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (process.env.NEXT_PUBLIC_ENVIRONMENT === 'development') return; // Prevent persistance in dev

    if (value === undefined) sessionStorage.removeItem(key);
    else sessionStorage.setItem(key, JSON.stringify(value));
  }, [key, value]);

  return [value, setValue];
}
